import React, { useEffect } from "react";
import {
  Header,
  Heading,
  HeadingGroup,
  Panel,
  Text,
  Input,
  Grid,
  Row,
  Col,
  Button,
} from "rsuite";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Auth.module.scss";

import { Formik } from "formik";
import { ErrorMessage } from "components";
import {
  changePasswordValidation,
} from "validation/AuthValidation";
import { toast } from "react-toastify";
import AuthAPI from "services/AuthAPI";
import { useDispatch, useSelector } from "react-redux";

export default function ChangePassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const userID = location.state?.userID || "";

  const apiInstance = new AuthAPI();

  const { isLoggedIn } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!location.state?.userID) {
      navigate("/");
    }
  }, [location, navigate]);

  return (
    <>
      <Header className={styles.top__header}>ॐ नमो भगवते वासुदेवाय नमः</Header>
      <div className={styles.container}>
        <div className={styles.login__card}>
          <div className={styles.logo}>
            <img src="/images/logo2.png" />
          </div>
          <Panel className={styles.panel} shaded>
            <HeadingGroup className="text-center">
              <Heading level={4} className="mb-5">
                Change Password 👋
              </Heading>
              <Text muted>Enter a new password to change</Text>
            </HeadingGroup>

            <div>
              <Formik
                initialValues={{
                  otp: "",
                  password: "",
                  confirmPassword: "",
                }}
                validationSchema={changePasswordValidation}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(true);
                  setTimeout(async () => {

                    const res = await apiInstance.changePasswordAPI(
                      values,
                      userID
                    );


                    if (res.statusCode === 200) {
                      toast.success(res.message);
                      setTimeout(() => {
                        navigate("/");
                      }, 1000);
                    } else {
                      toast.error(res.message);
                    }
                    setSubmitting(false);
                  }, 500);
                }}
              >
                {({
                  errors,
                  values,
                  touched,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid fluid>
                      <Row>
                        <Col sm={24}>
                          <div className="form-group">
                            <label className="form-label">
                              Verification Code
                            </label>
                            <Input
                              placeholder="Enter Verification Code"
                              value={values.otp || ""}
                              type="number"
                              onChange={(value) => {
                                setFieldValue("otp", value);
                              }}
                            />
                            <ErrorMessage
                              touched={touched.otp}
                              error={errors.otp}
                            />
                          </div>
                        </Col>

                        <Col sm={24}>
                          <div className="form-group">
                            <label className="form-label">New Password</label>
                            <Input
                              placeholder="Enter New Password"
                              value={values.password || ""}
                              type="password"
                              onChange={(value) => {
                                setFieldValue("password", value);
                              }}
                            />
                            <ErrorMessage
                              touched={touched.password}
                              error={errors.password}
                            />
                          </div>
                        </Col>

                        <Col sm={24}>
                          <div className="form-group">
                            <label className="form-label">
                              Confirm Password
                            </label>
                            <Input
                              placeholder="Enter Confirm Password"
                              value={values.confirmPassword || ""}
                              type="password"
                              onChange={(value) => {
                                setFieldValue("confirmPassword", value);
                              }}
                            />
                            <ErrorMessage
                              touched={touched.confirmPassword}
                              error={errors.confirmPassword}
                            />
                          </div>
                        </Col>

                        <Col sm={24}>
                          <Button
                            block
                            type="submit"
                            appearance="primary"
                            loading={isSubmitting}
                            className="mt-10"
                          >
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </Grid>
                  </form>
                )}
              </Formik>
            </div>
          </Panel>
        </div>
      </div>
    </>
  );
}
